import { render, staticRenderFns } from "./PlanGate.vue?vue&type=template&id=05e5e308&scoped=true"
import script from "./PlanGate.vue?vue&type=script&lang=js"
export * from "./PlanGate.vue?vue&type=script&lang=js"
import style0 from "./PlanGate.vue?vue&type=style&index=0&id=05e5e308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5e308",
  null
  
)

export default component.exports